<template>
  <div class="filter-item">
    <div class="md-layout md-gutter">
      <div class="md-layout-item">
        <md-field>
          <label>Поиск</label>
          <md-input v-bind:value="searchTextReg()"
                    v-on:input="searchTextReg($event)"  v-on:keyup.enter="searchChange"></md-input>
        </md-field>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'search',
  data () {
    return {
      value: null
    }
  },
  methods: {
    searchChange () {
      this.$emit('changeFilter')
    },
    searchTextReg (cl) {
      if (typeof (cl) !== 'undefined') {
        this.$store.state.filters.search = cl
      }
      return this.$store.state.filters.search
    }
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/registrationRequests/list/filters/search.vue